import React from "react"
export function MEFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Middle-East"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__middle-east" fill="#259245" fillRule="nonzero">
          <path id="prefix__Rectangle" d="M0 0h24v16H0z" />
        </g>
      </g>
    </svg>
  )
}
